import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { getServiceRequests } from "../../../redux/actions/service-requests.actions";
import { markNotificationSeen } from "../../../redux/actions/notifications.actions";
import { openNotificationService } from "../../../components/Notifications/notificationOpeners";
import history from "../../../history";

export default function useServiceRequestHandler() {
  const dispatch = useDispatch();

  // The socket payload carries the notification row (not the full service),
  // so when the user is already on the list we refetch it.
  function handleServiceRequest(notification) {
    const toastOptions = {
      autoClose: 4000,
      closeOnClick: false,
      draggable: false,
      theme: "colored"
    };

    if (history?.location?.pathname === "/service-requests") {
      dispatch(getServiceRequests());
    }

    toast.info(
      <div
        onClick={() => {
          // Open the request drawer in place; fall back to the old
          // list-page navigation if the payload can't be resolved.
          if (openNotificationService(dispatch, notification)) {
            dispatch(markNotificationSeen(notification.id));
          } else {
            history.push("/service-requests");
          }
          toast.dismiss();
        }}
      >
        New service request! Click to view.
      </div>,
      toastOptions
    );
  }

  return { handleServiceRequest };
}
